import { createElement } from 'react';
import { Checkbox } from '@alifd/next';
import './index.scss';
const OadpCheckboxGroup = function OadpCheckboxGroup({ name, dataSource, defaultValue, direction, disabled, ...otherProps }) {
    return (createElement(Checkbox.Group, Object.assign({ name: name, dataSource: dataSource, defaultValue: defaultValue, direction: direction, disabled: disabled }, otherProps)));
};
export default OadpCheckboxGroup;
